import { CropOriginalRounded } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import ImagesList from './ImagesList';
import { colors, HealtheraButton } from '../../../../healtheraComponents';
import useOutsideClick from '../../../../hooks/useOutsideClick';
import SimpleModal from '../../../Modal/SimpleModal';

import { createToggleModalOpen } from '../../../BranchDetails/utils';

const ImagePicker = ({ image, images, onChange }) => {
  const [isImageListOpen, setIsImageListOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const imagesListRef = useRef(null);

  useOutsideClick(imagesListRef, () => {
    if (isImageListOpen) {
      setIsImageListOpen(false);
    }
  });

  useEffect(() => {
    setIsLoading(false);
    setIsImageListOpen(false);
  }, [image.src]);

  const toggleImageListOpen = createToggleModalOpen(setIsImageListOpen);

  const handleImagePick = newImage => {
    onChange(newImage);
    setIsLoading(true);
  };

  return (
    <Container>
      {image?.src ? (
        <Image src={image.src} alt={image.alt} />
      ) : (
        <ImagePlaceholder>
          <CropOriginalRounded width={100} height={100} />
        </ImagePlaceholder>
      )}
      <Button onClick={toggleImageListOpen}>Pick an image</Button>
      <SimpleModal
        open={isImageListOpen}
        body={
          <ImagesListContainer ref={imagesListRef} $loading={isLoading}>
            <ImagesList currentImage={image} images={images} onPick={handleImagePick} />
          </ImagesListContainer>
        }
      />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ImagesListContainer = styled.div`
  background: rgba(255, 255, 255, 0.9);
  height: 100%;
  overflow-y: scroll;
`;

const Button = styled(HealtheraButton).attrs({
  padding: '5px',
  height: 'auto',
  margin: '10px 0 0 0'
})``;

const ImagePlaceholder = styled.p`
  margin: 0;
  svg {
    width: 100px;
    height: 100px;
    fill: ${colors.HEALTHERA_GREEN};
  }
`;

const Image = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
  padding: 5px;
  border: 1px solid ${colors.HEALTHERA_GREEN};
  border-radius: 5px;
`;

export default ImagePicker;
